import { useRef, useState } from 'react'

import { CustomTooltip } from '.'
import { NUMBER_LINES } from '../../constants'
import { Create, VisibilityOff } from '@mui/icons-material'
import { Visibility } from '@material-ui/icons'

const Input = ({ label, type, placeholder = ' - ', value, displayNC, displayPencilIcon, onChange, name, error, iconEl, id, disabled, disabledDefault, onBlur, labelBelow, onFocus, alternativeIcon, onIconLabelClick, multiple, className, onKeyDown, tooltip, inputStyle, linesAdded, maxLength = 524288, required = false }) => {
  const inputRef = useRef()

  const [passwordVisible, setPasswordVisible] = useState(false)

  // On blur
  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e)
    }
  }

  // On focus
  const handleFocus = (e) => {
    if (onFocus) {
      onFocus(e)
    }
  }

  // Input class
  let inputClasses = 'input-v2'

  if (className) {
    inputClasses += ` ${className}`
  }

  if (iconEl) {
    inputClasses += ' with-icon'
  }

  if (disabled && !linesAdded) {
    inputClasses += ' disabled'
  }

  if(required) {
    inputClasses += ' required'
  }

  return (
    <div className={`${inputClasses}  ${error ? 'error' : ''} `}>
      <div className="input-v2__inner">
        {iconEl && <label className="input-v2__icon" onClick={onIconLabelClick}>{alternativeIcon}{iconEl}</label>}
        {label && <label htmlFor={id ? id : name} className="input-v2__label">{label}</label>
        }
        {tooltip ? (
          <CustomTooltip content={tooltip} className="custom-tooltip--top-input">
            <div>
              <input
                type={type ? type === 'password' ? passwordVisible ? "text" : "password" : type : "text"}
                className={`input-v2__field ${displayPencilIcon && 'more-right-padding'}`}
                placeholder={displayNC ? 'NC' : placeholder}
                name={name}
                id={id ? id : name}
                value={value}
                onChange={onChange}
                autoComplete="invalid"
                disabled={disabled || disabledDefault}
                onBlur={handleBlur}
                onFocus={handleFocus}
                multiple={multiple}
                onKeyDown={onKeyDown}
                style={{ ...inputStyle, maxWidth: '100%' }}
                ref={inputRef}
                maxLength={maxLength}
              />
              {displayPencilIcon && <span className='pencil'>
                <Create fontSize='small' />
              </span>}
              {type === 'password' && <span className='password-icon' onClick={() => setPasswordVisible(!passwordVisible)}>
                {passwordVisible ? (
                  <VisibilityOff fontSize='small' />
                ) : (
                  <Visibility fontSize='small' />
                )}
              </span>}
            </div>
          </CustomTooltip>
        ) : (
          <>
            <input
              type={type ? type === 'password' ? passwordVisible ? "text" : "password" : type : "text"}
              className={`input-v2__field ${displayNC && 'display-nc'} ${displayPencilIcon && 'more-right-padding'}`}
              placeholder={displayNC ? 'NC' : placeholder}
              name={name}
              id={id ? id : name}
              value={value}
              onChange={onChange}
              autoComplete="invalid"
              disabled={disabled || disabledDefault}
              onBlur={handleBlur}
              onFocus={handleFocus}
              multiple={multiple}
              onKeyDown={onKeyDown}
              style={inputStyle}
              ref={inputRef}
              maxLength={maxLength}
            />
            {displayPencilIcon && <span className='pencil'>
              <Create fontSize='small' />
            </span>}
            {type === 'password' && <span className='password-icon' onClick={() => setPasswordVisible(!passwordVisible)}>
              {passwordVisible ? (
                <VisibilityOff fontSize='small' />
              ) : (
                <Visibility fontSize='small' />
              )}
            </span>}
          </>
        )}
        {labelBelow && <label htmlFor={id} className="input-v2__label">{labelBelow}</label>}
      </div>
      {error && <div className="input-v2__error">{error}</div>}
    </div>
  )
}

export default Input